var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'view-open-success view bg-white ' + _vm.className},[_c('comp-title',{attrs:{"title":_vm.title}}),(_vm.navs.length>1)?_c('nav-bar',{attrs:{"navs":_vm.navs}}):_vm._e(),_c('div',{staticClass:"success"},[_c('result',{attrs:{"result":_vm.resultObj},on:{"login-now":_vm.logout,"return-login":_vm.login}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }